import { NgModule, RouterModule, Routes } from './ng'
import {
  DataEntryExampleComponent,
  LoginComponent,
  UsersComponent,
  SearchTestsComponent,
  SearchGridFormatExampleComponent,
  SearchGridLinkDestinationExampleComponent,
  ExceptionExampleComponent,
  ErrorLogComponent,
  ErrorLogsComponent,
  ExamplesComponent,
  ExampleComponent,
  NotificationExampleComponent,
  ExampleFormlyComponent,
  CreateAccountComponent,
  ApplicationSettingComponent,
  ApplicationSettingsComponent,
  CheckpointComponent,
  CheckpointsComponent,
  RolesComponent,
  RoleComponent,
  UserComponent,
  DashboardComponent,
  UserWidgetSelectionComponent,
  AdminTypeLinksComponent,
  CountriesComponent,
  CountryComponent,
  SpkControlsExampleComponent,
  QueuesComponent,
  LandingPageComponent,
  ProjectSummaryComponent,
  NewProjectComponent
} from './components';

import { CanDeactivateGuard } from './services';



const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'dashboard', component: LandingPageComponent },
  { path: 'user-widget-selection', component: UserWidgetSelectionComponent, canDeactivate: [CanDeactivateGuard] },
  { path: 'data', component: DataEntryExampleComponent, canDeactivate: [CanDeactivateGuard] },
  { path: 'login', component: LoginComponent },
  { path: 'create-account', component: CreateAccountComponent },
  { path: 'users', component: UsersComponent },
  { path: 'user/:id', component: UserComponent },
  { path: 'search-grid-format', component: SearchGridFormatExampleComponent },
  { path: 'search-grid-link/:id', component: SearchGridLinkDestinationExampleComponent },
  { path: 'search-tests', component: SearchTestsComponent },
  { path: 'error-log/:id', component: ErrorLogComponent },
  { path: 'error-logs', component: ErrorLogsComponent },
  { path: 'application-setting/:name', component: ApplicationSettingComponent },
  { path: 'application-settings', component: ApplicationSettingsComponent },
  { path: 'examples', component: ExamplesComponent },
  { path: 'example/:id', component: ExampleComponent, canDeactivate: [CanDeactivateGuard] },
  { path: 'example-formly/:id', component: ExampleFormlyComponent, canDeactivate: [CanDeactivateGuard] },
  { path: 'exception-example', component: ExceptionExampleComponent },
  { path: 'notification-example', component: NotificationExampleComponent },
  { path: 'checkpoints', component: CheckpointsComponent },
  { path: 'checkpoint/:id', component: CheckpointComponent, canDeactivate: [CanDeactivateGuard] },
  { path: 'roles', component: RolesComponent },
  { path: 'countries', component: CountriesComponent },
  { path: 'country/:id', component: CountryComponent, canDeactivate: [CanDeactivateGuard] },
  { path: 'admin-type-links', component: AdminTypeLinksComponent },
  { path: 'role/:id', component: RoleComponent, canDeactivate: [CanDeactivateGuard] },
  { path: 'spk-controls-examples', component: SpkControlsExampleComponent, canDeactivate: [CanDeactivateGuard] },
  { path: 'queues', component: QueuesComponent },
  { path: 'projects', component: LandingPageComponent},
  { path: 'project/:id', component: ProjectSummaryComponent },
  { path: 'new-project', component: NewProjectComponent },
  { path: 'edit-project/:id', component: NewProjectComponent },
  { path: '**', redirectTo: 'login' }

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})

export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts